import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import useUiStore from '../../../store/uiStore';
import './AppLayout.css';

const { Header, Content } = Layout;

const AppLayout = () => {
  const { sidebarCollapsed } = useUiStore();

  return (
    <Layout className="app-layout">
      <Sidebar />
      <Layout style={{ marginLeft: sidebarCollapsed ? 80 : 240, transition: 'margin-left 0.2s' }}>
        <Header style={{ padding: 0, height: 56, lineHeight: '56px' }}>
          <TopBar />
        </Header>
        <Content className="app-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
